import { colors } from "@/utils/const";

export const styles = {
  input: {
    mt: 1.5,
    mb:0.5,
    "& .MuiInputBase-input": {
    },
    "& .MuiOutlinedInput-root": {
      border: "1px solid #E6E6E6",
      outline: "0px",
      borderRadius: "8px", // Set your desired border radius
      // fontSize: "10px",
      fontWeight: 400,
      lineHeight: "20px",
      //   padding: "3px",
      bgcolor: colors.white,
      height: "50px",
      color: `${colors.black} !important`,
      "& fieldset": {
        borderRaduis: "8px",
        border: "none",
        padding: "8px",
      },
      "&:hover fieldset": {
        border: "1px solid #E6E6E6",
      },

      "&.Mui-focused fieldset": {
        border: `2px solid ${colors.blue}`,
      },
    },
    "& .MuiOutlinedInput-root.Mui-disabled": {
      backgroundColor: "#23614F0D",
      border: "1px solid #E6E6E6",

      "&:hover": {
        border: "1px solid #E6E6E6",
      },
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#ccc",
    },

    "& .MuiInputLabel-outlined": {
      color: colors.blue,
    },
    "& legend": {
      width: "0",
    },
    "& .MuiInputLabel-outlined.Mui-focused": {
      color: colors.blue,
    },
    "& .MuiInputLabel-root": {
      fontSize: "14px",
      color: "rgba(0, 8, 20, 0.70)",
    },

    "& .MuiInputLabel-shrink": {
      fontSize: "16px",
      color: "#282781",
    },
    "& .MuiOutlinedInput-root.Mui-disabled": {
      backgroundColor: "rgba(243, 244, 246,0.5)", 
      border: "1px solid #E6E6E6",

      "& .MuiInputBase-input": {
        WebkitTextFillColor: colors.black,
      },

      "& fieldset": {
        border: "none",
      },
    },
    "& .MuiOutlinedInput-root.Mui-disabled .MuiInputBase-input": {
      WebkitTextFillColor: "rgba(0,0,0,.45)",
    },
    
  },
  label: {
    // fontSize: "1rem",
    color: colors.black,
    mb: 1.2,
    fontFamily: "inherit",
    fontWeight: "600",
  },
  checkbox: {
    color: colors.blue,
    "&.Mui-checked": {
      color: colors.blue,
    },
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  checkboxLabel: {
    color: "#6F6F6F",
    textDecoration: "underline",
    fontSize: "1rem",
    fontWeight: 400,
    mx: 0,
  },
  //
  outlinedInputRoot: {
    "& fieldset": {
      border: "1px solid #E6E6E6",
    },
    "&.Mui-focused fieldset": {
      border: "1px solid #E6E6E6",
    },
  },

  InputLabelProps: {
    color: `${colors.black} !important`,
    fontWeight: 400,
    right: 0,
    transformOrigin: "top right",
    backgroundColor: "white",
    paddingX: "10px",
    zIndex: 1,
    pointerEvents: "none",
    transition: "all 0.2s ease-in-out", // Smooth animation
  },
};
